export const ROUTE_PATH = '/archive-balance';
